<div class="factorBasedForm" *ngIf="formId">
    <span class="dynamic-form-title">{{title | translate}}</span>
    <gen-dynamic-form
            [formName]="formId"
            [formData]="formData"
            (formChange)="emit($event.form)"
            [listenToDataChange]="true"
            [editMode]="true"
            [disabled]="disabled"
            [submitted]="widgetFormInstanceSubmitted"
            [emitFormChangeEvenIfInvalid]="emitFormChangeEvenIfInvalid"
            (validateChange)="updateValidate($event)"
    ></gen-dynamic-form>
</div>
